import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from "./Nav";
import Home from "./Home";
import Contact from './Contact';
import Footer from './Footer';
import Products from './Products';
import Service from './Service';
import ElectricPalletTruck from './Products/ElectricPalletTruck';
import HandPalletTruck from './Products/HandPalletTruck'
import ScissorTrolley from './Products/ScissorTrolley';
import HighLiftPalletTruck from './Products/HighLiftPalletTruck';
import PowerStacker from './Products/PowerStacker';
import ManualStacker from './Products/ManualStacker';
import GoodsLift from './Products/GoodsLift';
import DockLeveler from './Products/DockLeveler';
import PaperRollerHandling from './Products/PaperRollerHandling';
import About from './About'

function App() {
  return (
    <>
    <BrowserRouter >
    <Nav />
    <Routes component>
      <Route path='/' >
        <Route index element={<Home />}/>
      </Route>
      <Route path='/products'>
        <Route index element={<Products />} />
        <Route path='electric-pallet-truck' element={<ElectricPalletTruck />} />
        <Route path='hand-pallet-truck' element={<HandPalletTruck />} />
        <Route path='scissor-trolley' element={<ScissorTrolley />} />
        <Route path='high-lift-pallet' element={<HighLiftPalletTruck />} />
        <Route path='power-stacker' element={<PowerStacker />} />
        <Route path='manual-stacker' element={<ManualStacker />} />
        <Route path='goods-lift' element={<GoodsLift />} />
        <Route path='dock-leveler' element={<DockLeveler />} />
        <Route path='paper-roller-handling' element={<PaperRollerHandling />} />
      </Route>
      <Route path='/service' element={<Service />}/>
      <Route path='/about' element={<About />}/>
      <Route path='/contact' element={ <Contact /> }/>
    </Routes>
    <Footer />
    </BrowserRouter>
    </>
  );
}

export default App;
